import { Button, Grid } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Field } from "modules/app/components/ContactDetails/Details/styles";
import React, { useEffect, useState } from "react";
import { NameRule } from "../fields/NameRule";
import { SubmitRule } from "../fields/SubmitRule";

function ByBroker({
  options,
  handleSubmit,
  company_id,
  distribution_type,
  rule,
}) {
  const [errors, setErrors] = useState({});
  const [attributes, setAttributes] = useState({
    name: rule.name || "",
    routing: rule.routing || "",
    users: rule.user_ids || [],
    company_teams: rule.company_team_ids || [],
    broker_role: rule.conditionals?.broker_role,
  });

  function handleClick(event) {
    event.preventDefault();

    const data = {
      rule: {
        company_id: company_id,
        priority: rule?.priority || 99,
        distribution_type: distribution_type,
        routing: "RoundRobin",
        name: attributes.name,
        conditionals: {
          broker_role: attributes.broker_role,
        },
      },
    };

    handleSubmit(data);
  }

  useEffect(() => {
    const attributesErrors = {};

    if (!attributes.broker_role) {
      attributesErrors.broker_role = "Esse campo é necessário";
    }

    if (!attributes.name) {
      attributesErrors.name = "Esse campo é necessário";
    }

    setErrors(attributesErrors);
  }, [attributes]);

  return (
    <>
      <div
        style={{
          marginTop: "28px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <NameRule
          attributes={attributes}
          setAttributes={setAttributes}
          errors={errors}
        />

        <Grid container alignItems="center" spacing={1}>
          <Grid item style={{ textAlign: "right", width: "20%" }}>
            {options.distribution_types.ByBroker}
          </Grid>

          <Grid item style={{ width: "50%" }}>
            <Autocomplete
              value={{
                id: attributes.broker_role,
                label: options.distribution_roles[attributes.broker_role],
              }}
              style={{ marginTop: 20 }}
              options={Object.keys(options.distribution_roles).map((item) => ({
                id: item,
                label: options.distribution_roles[item],
              }))}
              openOnFocus={true}
              fullWidth
              renderInput={(params) => (
                <Field
                  {...params}
                  label={options.distribution_types.ByBroker}
                  variant="outlined"
                  helperText={errors.broker_role}
                />
              )}
              onChange={(_event, value) => {
                setAttributes({
                  ...attributes,
                  broker_role: value?.id,
                });
              }}
              getOptionLabel={(field) => field.label}
              getOptionSelected={(option, value) => option.id === value.id}
            />
          </Grid>
        </Grid>

        <SubmitRule
          disabled={Object.keys(errors).length > 0}
          handleClick={handleClick}
          rule={rule}
        />
      </div>
    </>
  );
}

export default ByBroker;
